module.exports = __webpack_public_path__ + "static/media/brush--yellow.f8239b02.svg";